import React, { useEffect } from "react";
import { Form, Formik } from "formik";
import { useDb } from '../../context/DbContext'
export function Infout() {
  const {textos , loadComment , createdComment}  =  useDb()
  useEffect(() => {
    loadComment() ;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  } , [] );
  function typed( data , int){
    if (data > 0 ) {
      if (int === 1) {
      return( <p className="parafhOne">{'De 4 hasta 25 caracteres ('+data+')'}</p> )
      } else {
        return( <p className="parafhTwo">{'De 2 hasta 100 caracteres ('+data+')'}</p> )
      }
    }
  }
  function Validation(values) {
      let validation = false
      if ( ( values.user === "" || values.comment === "" ) ||  ( values.user[0] === " " || values.comment[0] === " " )) {
        window.alert("Tu usuario o tu comentario está vacio!");
      } else if( values.user.length < 4 ) {
        window.alert("Tu usuario requiere más de vos");
      }else if(  values.comment.length < 2  ){
        window.alert("Tu comentario requiere más de vos");
      } else if ( values.user.length > 25  ) {
        window.alert("Tu usuario contiene más de 20 caracteres");
      }else if (values.comment.length > 100) {
        window.alert("Tu comentario contiene más 100 caracteres");
      }else{
        validation = true
      }
      return validation
  }

  function closeEngine() {
    window.alert("Tu comentario fue enviado, Gracias a tí y buen viaje!!")
  }

 return (
    <section className="card-out"  >
      <article>
        <hgroup className="container_one_hgroup">
          <h2 id="left_semant">Última actualización</h2>
          <time dateTime="10/12/2025">Página actualizada 1-11-2026</time>
        </hgroup>
        <footer className="container_one_footer">
          <Formik initialValues={{
              user: "",
              comment: "",
            }}
            onSubmit={async (values, actions) => {
              if(Validation(values) === true){
                try {
                  await createdComment(values);
                  actions.resetForm();
                  closeEngine()
                } catch (error) {
                  closeEngine()
                }
              }
            }}
          >
          {({ handleChange, handleSubmit, values, isSubmitting }) => (
            <Form onSubmit={handleSubmit} className="container_form">
              <div className="users-form-view">
                <label htmlFor="send">Tu usuario</label>
                <br />
                <input type="text" id="textInput" name="user" placeholder="Ingresa tu usuario" onChange={handleChange} value={values.user} />
                {typed(values.user.length , 1)}  
              </div>
              <br />
              <div className="users-form-view">
                <label htmlFor="send">Ingresa tu comentario</label>
                <br />
                <textarea type="text" id="send" name="comment" placeholder="Tu comentario" onChange={handleChange} value={values.comment} />
                {typed(values.comment.length , 2)} 
              </div>
              <br />
              <button type="submit" id="btn_send" disabled={isSubmitting}> {" "} {isSubmitting ? "Enviando" : "Enviar"} comentario </button>
            </Form> )}
          </Formik>
        </footer>
        <hgroup className="container_two_hgroup">
          <h2 id="left_semant">Artículos</h2> <time dateTime="03/08/2025">Actualización artículo 10-10-2026</time>
        </hgroup>
        <footer className="container_end_footer">
          <p className="YouLike" > Comentarios <code>({textos.length})</code> </p>
          <div>
            { textos.map((texto, index) => (
              <div key={index} className="conteinerSuper">
                <div className="containerGif">
                  <p className="gridParafh">{texto.user.substring(0, 24)}{": "}</p>{" "}
                    <p className="gridText">{" "}<code>{texto.createAt.substring(0, 10)}{" "}{`[hora${` ` + texto.createAt.substring(11, 19)}]`}{" "}</code>{" "}</p>
                  </div>
                  <div className="containerComment">
                  <p><code> {texto.comment.substring(0, 99)} </code>{" "}</p>
                </div>
              </div>
              ))
            }
          </div>
        </footer>
      </article>
    </section>
  );
}